import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={false}
      // copyright={`京ICP备13053479号-2 | 京公网安备 11010502037293号 | 使用条款 | Cookies和隐私策略`}
      links={[
        {
          key: '0',
          title: '©Copyright ' + currentYear + ' ABB  |',
          href: '',
          blankTarget: false,
        },
        {
          key: '京ICP备13053479号-2',
          title: '京ICP备13053479号-2',
          href: 'https://beian.miit.gov.cn/#/Integrated/index',
          blankTarget: true,
        },
        {
          key: '1',
          title: '|',
          href: '',
          blankTarget: false,
        },
        {
          key: '京公网安备 11010502037293号',
          title: '京公网安备 11010502037293号',
          href: 'http://www.beian.gov.cn/portal/index',
          blankTarget: true,
        },
        {
          key: '2',
          title: '|',
          href: '',
          blankTarget: false,
        },
        {
          key: '使用条款',
          title: '使用条款',
          href: 'https://new.abb.com/provider-information',
          blankTarget: true,
        },
        {
          key: '3',
          title: '|',
          href: '',
          blankTarget: false,
        },
        {
          key: 'Cookies和隐私策略',
          title: 'Cookies和隐私策略',
          href: 'http://new.abb.com/privacy-policy',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
